import { ModeComment } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import MessageDialog from "../MessageDialog/index.js";

export default memo(({
  entryId, subordinateId, userName = "", tooltip = "messages", placement = "bottom", buttonSize = "small", fontSize = "small",
}) => {
  const { t } = useTranslation();
  const actions = {};

  return (
    <>
      <Tooltip title={t(tooltip)} placement={placement} disableTouchListener>
        <IconButton
          size={buttonSize}
          onClick={() => {
            actions.open(entryId, subordinateId, userName);
          }}
        >
          <ModeComment fontSize={fontSize} />
        </IconButton>
      </Tooltip>
      <MessageDialog actions={actions} />
    </>
  );
});
